import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { Count, Title } from '../SearchTitle.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaSearchTitle = /*#__PURE__*/forwardRef(({
  mediaResult,
  isLoading,
  showAll
}, ref) => {
  const {
    t
  } = useTranslation();
  const searchTerm = mediaResult?.searchTerm ?? '';
  const resultCount = mediaResult?.total ?? 0;
  const title = showAll && searchTerm.length === 0 ? t('search.showingAll') : `‘${searchTerm}‘`;
  const mediaTypeText = t('search.resultCount', {
    count: resultCount
  });
  return /*#__PURE__*/_jsx(PlayContainer, {
    width: "small",
    children: isLoading ? /*#__PURE__*/_jsx(TitlePlaceholder, {}) : /*#__PURE__*/_jsxs(Title, {
      ref: ref,
      children: [title, /*#__PURE__*/_jsx(Count, {
        children: mediaTypeText
      })]
    })
  });
});
const TitlePlaceholder = styled.div.withConfig({
  displayName: "MediaSearchTitle__TitlePlaceholder",
  componentId: "sc-1o3p8gt-0"
})(["height:25px;width:30%;margin:17px 0 27px 0;border-radius:2px;background-color:", ";"], Colors.GREY_3a3a3a);